import { GetAllMulticoteBlendsResponse } from "../../../Models/ServerModels/AgriSolution/GetAllMulticoteBlendsResponse";
import { ApiResponse } from "../../../Models";
import { IHttpService } from "../IHttpService";
import { ApiServiceBase } from "./ApiServiceBase";
import Config from "../../../Configs";

export default class SolutionApiService extends ApiServiceBase {
    constructor(client: IHttpService) {
        super(client);
    }

    async getAllMulticoteBlends(): Promise<ApiResponse<GetAllMulticoteBlendsResponse>> {
        return await this._client.get<GetAllMulticoteBlendsResponse>(Config.apiPaths.getMulticoteBlends);
    }
}
